import React from 'react';
import { Card, List, Checkbox } from 'antd';

const Question = ({ result, question, onChange }) => {
  const { value = [], type, title } = result;
  const { properties } = question;
  const { choices } = properties;

  const checked = item => {
    return value && value.length && value.includes(item.id);
  };

  const onCheck = (e, item) => {
    if (e.target.checked && !checked(item)) {
      if (!value) {
        onChange([item.id]);
      } else if (!value.includes(item.id)) onChange([...value, item.id]);
    } else if (!e.target.checked && checked(item)) {
      const values = [...(value || [])];
      const Idx = values.findIndex(v => v === item.id);
      if (Idx >= 0) {
        values.splice(Idx, 1);
        onChange(values);
      }
    }
  };

  const getActions = item => {
    return [<Checkbox key={item.id} checked={checked(item)} onChange={e => onCheck(e, item)} />];
  };

  return (
    <Card>
      <p>Title: {title}</p>
      <p>Type: {type}</p>
      <List
        itemLayout="horizontal"
        dataSource={choices}
        renderItem={item => (
          <List.Item actions={getActions(item)}>
            <List.Item.Meta title={item.label} actions />
          </List.Item>
        )}
      />
    </Card>
  );
};

export default Question;
